import styled from 'styled-components';

import { linkStyles, paragraphStyles } from '@components/blocks/blocks.styles';
import { media } from '@theme/media';
import { FONT_SIZE, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

import { containerStyles } from '../pdp.styles';

export const Container = styled.div`
  ${containerStyles};

  ${media.desktop} {
    grid-template-columns: 29% auto calc(24% - 200px);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  ${media.desktop} {
    flex-direction: row;
  }
`;

export const ArtistName = styled.a`
  ${typography({})};
  align-self: flex-start;
  margin-top: ${OFFSET.S};
  margin-bottom: ${OFFSET.S};
  text-transform: uppercase;
  min-width: 30%;

  ${media.mobile} {
    ${typography({ size: FONT_SIZE.M })};
    padding-right: 20px;
  }

  ${media.desktop} {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const ArtistBiographyWrapper = styled.div``;

export const ArtistBiography = styled.div`
  p {
    ${paragraphStyles};

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  blockquote {
    margin: ${OFFSET.M} 0 ${OFFSET.M};

    ${media.tablet} {
      margin: ${OFFSET.L} 0 ${OFFSET.L};
    }
  }

  > * {
    margin-top: 0;
  }

  a {
    ${linkStyles};
  }
`;
